import styled from '@emotion/styled';

export const Unlisted = styled.ul`
  list-style: none;
`;
